/**
 * Phase 18 / Slice A — i18n helper for the vertical-key → human-label
 * lookup. Backed by the `verticals.{key}` namespace in `i18n/{en,sv}.json`.
 *
 * When a key has no entry (e.g. an operator added a new pack to disk
 * but the SPA hasn't shipped a translation yet), the key itself is
 * returned so the UI stays functional rather than blank or crashing.
 * That fallback intentionally surfaces the raw key so the missing
 * translation is visible during review.
 */
import type { TFunction } from "i18next";

export function verticalLabel(key: string, t: TFunction): string {
  // i18next returns the key when the path is missing AND `defaultValue`
  // isn't set; passing `defaultValue` explicitly is the clearest way to
  // signal intent + survive a missing-namespace warning.
  return t(`verticals.${key}`, { defaultValue: key });
}
